var exports = {
  "N1": "headerContainer__KTI6UJ",
  "Hc": "workflowNameHeading__bA802l",
  "_m": "dialogFormControl__DwSHfL",
  "Ym": "dialogTextInput__4F9_4x",
};

module.exports = exports;
